export default __webpack_public_path__ + "static/media/building.cc0c2a6b.svg";